import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { selectUserRole } from '../+state/user/user.selectors';

export const hasAccessToNoOrganizationGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectUserRole).pipe(map(role => (!role ? true : router.createUrlTree(['/']))));
};
